import { useEffect, useState } from "react";
import { getAccountIdentity } from "../../services/apiService";
import { setAccessTokenToHeader } from "../../services/coreApiService";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { ICred } from "../../types/login.types";
import { LocalStorageKeys } from "../../utils/constant";
import { useAppDispatch } from "../../redux/stateHooks";
import { setAuthenticatedCredentials } from "../../redux/reducers/loginSlice";
import {
  setAccountDetails,
  setIsAccountLogedIn,
} from "../../redux/reducers/accountSlice";
import { IUserIdentityData } from "../../types/account.types";
import { useNavigate } from "react-router-dom";
import { removeAllFromStorage } from "../../utils/helpers";
import { resetState } from "../../redux/store";

function Account() {
  const navigate = useNavigate();
  const [userIdentity, setUserIdentity] = useState<IUserIdentityData>(null);
  const [credentials] = useLocalStorage<ICred>(
    LocalStorageKeys.CREDENTIALS,
    null
  );
  const dispatch = useAppDispatch();
  const fetchAccountIdentity = async () => {
    try {
      const userIdentity = await getAccountIdentity();
      setUserIdentity(userIdentity.data);
      dispatch(setAccountDetails(userIdentity.data));
    } catch (error) {
      console.error("Error fetching account identity:", error);
    }
  };

  useEffect(() => {
    if (credentials) {
      setAccessTokenToHeader(
        credentials.access_token,
        credentials.instance_url
      );
      dispatch(setAuthenticatedCredentials(credentials));
      dispatch(setIsAccountLogedIn(true));

      fetchAccountIdentity();
    }
  }, []);
  const handleContinue = () => {
    // console.log("handle continue");
    navigate("/app-tabs-items-component/loadtable");
  };

  const handleLogout = () => {
    removeAllFromStorage();
    dispatch(resetState());
    navigate("/login");
  };

  return (
    <div className="contentCntr dark-bg">
      <div className="loginConatiner">
        <div className="loginContent">
          {userIdentity ? (
            <>
              <h3 className="title">Hello {userIdentity?.display_name}</h3>
              <h3 className="title mt-4">{userIdentity?.email}</h3>
              <button
                className="btn btn-primary btn-lg font-13 active mt-3 mr-2"
                onClick={handleContinue}
              >
                Continue
              </button>
              <button
                className="btn btn-primary btn-lg font-13 active mt-3"
                onClick={handleLogout}
              >
                Logout
              </button>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Account;
